{
	"printDate": "Délivré le",
	"reportPeriod": "Période du rapport",
	"emissionInfo": "Émis par",
	"eventDate": "Date de l'événement"
}
